import React, { useState, useCallback } from 'react';
import HomeLoader from './HomeLoader';
import Hero from './Hero';
import ViveLibreSection from './ViveLibreSection';
import Services from './Services';
import AtelierHomeSection from './AtelierHomeSection';
import Testimonials from './Testimonials';
import Gallery from './Gallery';

const HomePage = ({ onShowLogin }) => {
  const [showLoader, setShowLoader] = useState(true);
  const handleLoaderDone = useCallback(() => setShowLoader(false), []);

  return (
    <>
      {showLoader && <HomeLoader onDone={handleLoaderDone} />}
      <Hero onShowLogin={onShowLogin} />
      <ViveLibreSection />
      <Gallery />
      <Testimonials />
      <AtelierHomeSection />
      <Services />
    </>
  );
};

export default HomePage;
